import { render, staticRenderFns } from "./TfootProfileCluster.vue?vue&type=template&id=2ef227a0"
import script from "./TfootProfileCluster.vue?vue&type=script&lang=js"
export * from "./TfootProfileCluster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports